// extracted by mini-css-extract-plugin
export default {"block":"rd","smallprint":"sd","asterisk":"td","label":"ud"};